import { organisationConstants } from '../../_constants/organisation.constants';
const initialState = { unsub_assess_loading : true, unsub_assess: '',unsub_assess_error: false};

export function unsubmitAssessment(state = initialState, action) {
    switch (action.type) {
      case organisationConstants.REQUEST_UNSUBMITTED_ASSESSMENT:
        return {
            unsub_assess_loading: true,
            unsub_assess: '',
            unsub_assess_error: false
        };
      case organisationConstants.RESPONSE_UNSUBMITTED_ASSESSMENT:
        return {
            unsub_assess_loading: false,
            unsub_assess: action.unsub_assess,
            unsub_assess_error: false
        };
      case organisationConstants.ERROR_UNSUBMITTED_ASSESSMENT:
        return { 
            unsub_assess_loading: false,
            unsub_assess: '',
            unsub_assess_error: true
        };
      default:
        return state
    }
}



// WEBPACK FOOTER //
// ./src/_reducers/organisation/unsubmittedAssessment.reducer.js